import { Select } from 'antd'
import { SelectProps } from 'antd/es/select'
import { FC } from 'react'
import { MaintenanceProductStatus } from '@/domain/models/maintenanceProductStatus.ts'

export const MaintenanceProductStatusSelector: FC<SelectProps> = (props) => {
  return (
    <Select
      showSearch={false}
      filterOption={false}
      placeholder="Seleccione un estado"
      {...props}
    >
      {MaintenanceProductStatus.toEntries().map(([ key, value ]) => (
        <Select.Option key={key} value={value.value}>{value.label()}</Select.Option>
      ))}
    </Select>
  )
}
